// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".msdsCard .customCardbody {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n  margin-top: 0 !important;\n}\n.msdsCard .customCardbody .q-field__inner {\n  padding-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
